<template>
    <v-container>
      <rental-form schema="new" title="NUEVO GASTO" />
    </v-container>
  </template>
  
  <script>
  import RentalForm from "../../components/Forms/spentForm.vue";

  export default {
    components: { RentalForm },
  };
  </script>
  
  <style></style>
  